import service from '@/services/SIRcon_aut_mail';

export default {
  namespaced: true,

  actions: {
    /**
     * Envía o reenvía el código de verificación.
     * Si no se pasa `value`, usa el almacenado en el estado.
     */
    send({ dispatch, rootGetters }, value) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRcon_aut_mail: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRcon_aut_mail: [
              {
                piiaut_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0,
                piicod_otp: value.otpCode,
                picaut_mail: value.email,
              },
            ],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data?.dsSIRcon_aut_mail;

            if (data?.eeEstados?.[0]?.Returnid === 0) {
              resolve(data);
            } else if (data?.eeEstados?.[0]?.Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data?.eeEstados?.[0]?.Returnid || null,
                message: data?.eeEstados?.[0]?.Estado || null,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error?.type === undefined) {
              notification = {
                code: error?.name || null,
                message: error?.message || null,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },

    sendFirstEmail({ dispatch, rootGetters }, value) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRcon_aut_mail: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRcon_aut_mail: [
              {
                piiaut_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0,
                piicod_otp: atob(rootGetters['SIRcon_aut/state'].codeVerify),
                picaut_mail: value.email,
              },
            ],
          },
        };

        let notification;

        service
          .firstEmail(payload)
          .then((response) => {
            const data = response.data?.dsSIRcon_aut_mail;

            if (data?.eeEstados?.[0]?.Returnid === 0) {
              resolve(data);
            } else if (data?.eeEstados?.[0]?.Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data?.eeEstados?.[0]?.Returnid || null,
                message: data?.eeEstados?.[0]?.Estado || null,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error?.type === undefined) {
              notification = {
                code: error?.name || null,
                message: error?.message || null,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
